import { Component, Optional } from '@angular/core';
import { hasValue } from '../shared/empty.util';
import { KlaroService } from '../shared/cookies/klaro.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { AuthorizationDataService } from '../core/data/feature-authorization/authorization-data.service';
import { FeatureID } from '../core/data/feature-authorization/feature-id';
import { NavigationTab } from 'src/themes/dspace/app/header/navigation-tabs.interface';
import { NavigationService } from '../shared/navigation.service';
import { HostWindowService, WidthCategory } from '../shared/host-window.service';

@Component({
  selector: 'ds-footer',
  styleUrls: ['footer.component.scss'],
  templateUrl: 'footer.component.html'
})
export class FooterComponent {
  readonly baseUrl = environment.baseUrl;
  readonly maxMobileWidth = WidthCategory.MD;
  readonly year = new Date().getFullYear();
  readonly navigationTabs: NavigationTab[] = [
    { value: 'Home', path: 'home' },
    { value: 'Contact Us', path: 'info/feedback' },
    { value: 'Privacy Policy', path: 'privacy-policy' },
    { value: 'Terms and Conditions', path: 'terms-and-conditions' }
  ];
  dateObj: number = Date.now();
  isMobile$: Observable<boolean>;

  /**
   * A boolean representing if to show or not the top footer container
   */
  showTopFooter = false;
  showPrivacyPolicy = environment.info.enablePrivacyStatement;
  showEndUserAgreement = environment.info.enableEndUserAgreement;
  showSendFeedback$: Observable<boolean>;
  goToExternalLink: Function;

  constructor(
    navigationService: NavigationService,
    @Optional() private cookies: KlaroService,
    private authorizationService: AuthorizationDataService,
    private windowService: HostWindowService
  ) {
    this.showSendFeedback$ = this.authorizationService.isAuthorized(FeatureID.CanSendFeedback);
    this.goToExternalLink = navigationService.goToExternalLink;
  }

  ngOnInit(): void {
    this.isMobile$ = this.windowService.isUpTo(this.maxMobileWidth);
  }

  showCookieSettings() {
    if (hasValue(this.cookies)) {
      this.cookies.showSettings();
    }
    return false;
  }
}
